export const currencyFormatter = (value: any) => {
    return `$${Number(value || 0).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}`
}